import axios from 'axios';

// 创建axios实例
var instance = axios.create({timeout: 1000 * 12});
// 设置post请求头
// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// baseURL 切换
if (process.env.NODE_ENV == 'development') {
    // console.log('switch to dev')
    instance.defaults.baseURL = 'http://localhost:5254/';
} else if (process.env.NODE_ENV == 'debug') {    
    instance.defaults.baseURL = '';
} else if (process.env.NODE_ENV == 'production') {    
    instance.defaults.baseURL = 'http://118.195.226.55:5254/';
    // instance.defaults.baseURL = 'http://localhost:11451/';
}

// 用的时候 import axios from '@/utils/http'
export default instance;
